/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { TrackActivity } from './TrackActivity';
import {
    TrackActivityFromJSON,
    TrackActivityFromJSONTyped,
    TrackActivityToJSON,
} from './TrackActivity';
import type { VersionMetadata } from './VersionMetadata';
import {
    VersionMetadataFromJSON,
    VersionMetadataFromJSONTyped,
    VersionMetadataToJSON,
} from './VersionMetadata';

/**
 * 
 * @export
 * @interface TrackLibraryResponse
 */
export interface TrackLibraryResponse {
    /**
     * 
     * @type {number}
     * @memberof TrackLibraryResponse
     */
    latestChainBlock: number;
    /**
     * 
     * @type {number}
     * @memberof TrackLibraryResponse
     */
    latestIndexedBlock: number;
    /**
     * 
     * @type {number}
     * @memberof TrackLibraryResponse
     */
    latestChainSlotPlays: number;
    /**
     * 
     * @type {number}
     * @memberof TrackLibraryResponse
     */
    latestIndexedSlotPlays: number;
    /**
     * 
     * @type {string}
     * @memberof TrackLibraryResponse
     */
    signature: string;
    /**
     * 
     * @type {string}
     * @memberof TrackLibraryResponse
     */
    timestamp: string;
    /**
     * 
     * @type {VersionMetadata}
     * @memberof TrackLibraryResponse
     */
    version: VersionMetadata;
    /**
     * 
     * @type {Array<TrackActivity>}
     * @memberof TrackLibraryResponse
     */
    data?: Array<TrackActivity>;
}

/**
 * Check if a given object implements the TrackLibraryResponse interface.
 */
export function instanceOfTrackLibraryResponse(value: object): value is TrackLibraryResponse {
    let isInstance = true;
    isInstance = isInstance && "latestChainBlock" in value && value["latestChainBlock"] !== undefined;
    isInstance = isInstance && "latestIndexedBlock" in value && value["latestIndexedBlock"] !== undefined;
    isInstance = isInstance && "latestChainSlotPlays" in value && value["latestChainSlotPlays"] !== undefined;
    isInstance = isInstance && "latestIndexedSlotPlays" in value && value["latestIndexedSlotPlays"] !== undefined;
    isInstance = isInstance && "signature" in value && value["signature"] !== undefined;
    isInstance = isInstance && "timestamp" in value && value["timestamp"] !== undefined;
    isInstance = isInstance && "version" in value && value["version"] !== undefined;

    return isInstance;
}

export function TrackLibraryResponseFromJSON(json: any): TrackLibraryResponse {
    return TrackLibraryResponseFromJSONTyped(json, false);
}

export function TrackLibraryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrackLibraryResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'latestChainBlock': json['latest_chain_block'],
        'latestIndexedBlock': json['latest_indexed_block'],
        'latestChainSlotPlays': json['latest_chain_slot_plays'],
        'latestIndexedSlotPlays': json['latest_indexed_slot_plays'],
        'signature': json['signature'],
        'timestamp': json['timestamp'],
        'version': VersionMetadataFromJSON(json['version']),
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(TrackActivityFromJSON)),
    };
}

export function TrackLibraryResponseToJSON(value?: TrackLibraryResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'latest_chain_block': value.latestChainBlock,
        'latest_indexed_block': value.latestIndexedBlock,
        'latest_chain_slot_plays': value.latestChainSlotPlays,
        'latest_indexed_slot_plays': value.latestIndexedSlotPlays,
        'signature': value.signature,
        'timestamp': value.timestamp,
        'version': VersionMetadataToJSON(value.version),
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(TrackActivityToJSON)),
    };
}

